import moment from "moment";

/**
 *
 * @param {number} patient_id id del paciente para cambiar su estado (activo,pasivo)
 * @param {string} state estado que se asignara al paciente
 * @returns
 */
export const updateState = async (resource, patient_id, state) => {
  let result;
  await resource
    .put(`api/${window.getApiUrlEntity(localStorage.getItem("perfil"))}patient/update_state/${patient_id}`, {
      state: state,
    })
    .then(
      (response) => {
        result = response.body.patient;
      },
      (response) => {
        console.log(response);
      }
    );
  return result;
};

export const getAllPatient = async (resource, page) => {
  let result;
  await resource.get(`api/${window.getApiUrlEntity(localStorage.getItem("perfil"))}patient?page=${page}`).then(
    (response) => {
      result = response.body.patient;
    },
    (response) => {
      console.log(response);
    }
  );
  return result;
};

export const storePatient = async (resource, data) => {
  let result;
  await resource
    .post(`api/${window.getApiUrlEntity(localStorage.getItem("perfil"))}patient`, {
      ...data,
      birth_date: moment(data.birth_date).format("YYYY/MM/DD"),
    })
    .then(
      (response) => {
        console.log(response);
      },
      (response) => {
        console.log(response);
      }
    );
  return result;
};

export const updatePatient = async (resource, id, data) => {
  let result;
  await resource
    .put(`api/${window.getApiUrlEntity(localStorage.getItem("perfil"))}patient/` + id, {
      ...data,
    })
    .then(
      (response) => {
        result = response.body;
      },
      (response) => {
        result = response;
        console.log(response);
      }
    );
  return result;
};

export const getPatient = async (resource, id) => {
  let result;
  await resource.get(`api/${window.getApiUrlEntity(localStorage.getItem("perfil"))}patient/` + id).then(
    (response) => {
      result = response.body.patient;
    },
    (response) => {
      console.log(response);
    }
  );
  return {
    ...result,
  };
};

export const findPatientByRut = async (resource, rut) => {
  let result;
  await resource.get(`api/${window.getApiUrlEntity(localStorage.getItem("perfil"))}patient/findbyrut/${rut}`).then(
    (response) => {
      if (response.body.patient.length !== 0) {
        result = response.body.patient[0];
      }
    },
    (response) => {
      console.log(response);
    }
  );

  return result;
};
export const findPatientByPassaport = async (resource, rut) => {
  let result;
  await resource.get(`api/${window.getApiUrlEntity(localStorage.getItem("perfil"))}patient/findbypassport/${rut}`).then(
    (response) => {
      if (response.body.patient.length !== 0) {
        result = response.body.patient[0];
      }
    },
    (response) => {
      console.log(response);
    }
  );

  return result;
};
export const findPatientByOtherIdentification = async (resource, rut) => {
  let result;
  await resource.get(`api/${window.getApiUrlEntity(localStorage.getItem("perfil"))}patient/find_by_other_indentification/${rut}`).then(
    (response) => {
      if (response.body.patient.length !== 0) {
        result = response.body.patient[0];
      }
    },
    (response) => {
      console.log(response);
    }
  );

  return result;
};

export const findPatientByMotherRut = async (resource, rut) => {
  let result;
  await resource.get(`api/${window.getApiUrlEntity(localStorage.getItem("perfil"))}patient/findbymother_rut/${rut}`).then(
    (response) => {
      console.log(response);
      if (response.body.patient.length !== 0) {
        result = response.body.patient[0];
      }
    },
    (response) => {
      console.log(response);
    }
  );

  return result;
};
export const findPatientByFileNumber = async (resource, file_number) => {
  let result;
  await resource.get(`api/${window.getApiUrlEntity(localStorage.getItem("perfil"))}patient/findby_filenumber/${file_number}`).then(
    (response) => {
      if (response.body.patient.length !== 0) {
        result = response.body.patient[0];
      }
    },
    (response) => {
      console.log(response);
    }
  );

  return result;
};
export const getPatientsByAll = async (resource, data) => {
  let result;
  await resource.post(`api/${window.getApiUrlEntity(localStorage.getItem("perfil"))}patient/find_by_all`, data).then(
    (response) => {
      result = response.body.patient;
    },
    (response) => {
      console.log(response);
    }
  );

  return result;
};

export const updateFileNumber = async (resource, id, number) => {
  let result;
  if (window.localStorage.getItem("stablishment") === "1803") {
    await resource
      .put(`api/${window.getApiUrlEntity(localStorage.getItem("perfil"))}patient/update_file_hae/${id}`, {
        file_number_hae: number,
      })
      .then(
        (response) => {
          result = response.body.patient;
        },
        (response) => {
          console.log(response);
        }
      );
  } else {
    await resource
      .put(`api/${window.getApiUrlEntity(localStorage.getItem("perfil"))}patient/update_file_number/${id}`, {
        file_number: number,
      })
      .then(
        (response) => {
          result = response.body.patient;
        },
        (response) => {
          console.log(response);
        }
      );
  }

  return result;
};

export const findPatientByProvisionalRut = async (resource, rut) => {
  let result;
  await resource.get(`api/${window.getApiUrlEntity(localStorage.getItem("perfil"))}patient/find_by_provisional_rut/${rut}`).then(
    (response) => {
      if (response.body.patient.length !== 0) {
        result = response.body.patient[0];
      }
    },
    (response) => {
      console.log(response);
    }
  );

  return result;
};

//ZOOM

export const generateSignature = async (resource, apiKey, apiSecret, meetingNumber, role) => {
  let result;
  await resource
    .get(`api/${window.getApiUrlEntity(localStorage.getItem("perfil"))}patient/generate_signature/${apiKey}/${apiSecret}/${meetingNumber}/${role}`)
    .then(
      (response) => {
        result = response.body;
      },
      (response) => {
        console.log(response);
      }
    );
  return result;
};

export const recursiveChangePatient = async (resource, data) => {
  let result;
  await resource.post(`api/${window.getApiUrlEntity(localStorage.getItem("perfil"))}patient/recursive_change_patient`, data).then(
    (response) => {
      console.log(response);
      result = response.body;
    },
    (response) => {
      console.log(response);
    }
  );
  return result;
};
